import { Box, Button, Typography } from "@mui/material";
import { SHA256 } from "crypto-js";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import CustomInput from "../../components/CustomInput";
import { REACT_EMPLOYEE_LOGIN_SCREEN } from "../../constants/ReactEndPoints";
import { terminalRegistration } from "../../services/FunctionKeysService";
import OnboardLayout from "../../components/layout-components/OnboardLayout";
import CommonUtil from "../../util/CommonUtils";
import { useTranslation } from "react-i18next";
import { resetDefaultLanguage } from "../../i18n/languageService";

const myTime = 'MYTIME';

const TerminalRegistration = () => {
    const {t} = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    let encryptedUUID = SHA256(uuidv4()).toString();
    const navigate = useNavigate();


    useEffect(() => {
      resetDefaultLanguage();
    }, []);

    const [error, setError] = useState({
        companyCode: "",
        terminalId: "",
    });

    const [payload, setPayload] = useState({
        companyCode: "",
        uuid: encryptedUUID,
        terminalId: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        let updatedValue = value;
        if (name === 'companyCode') {
            updatedValue = value.toUpperCase();
        }
        setPayload({
            ...payload,
            [name]: updatedValue,
        });

        setError({
            ...error,
            companyCode: "",
            terminalId: ""
        })
    };

    const handleSubmit = () => {
        if (isValidToSubmit()) {
            let companyCode = '';
            
            if (payload?.companyCode?.includes('_')) {
                companyCode = payload?.companyCode?.split('_')?.[1];
            } else {
                companyCode = payload?.companyCode;
            }

            let updatedPayload = {
                companyCode: companyCode,
                uuid: payload?.uuid,
                terminalId: payload.terminalId,
                companyCodeWithCohort: payload?.companyCode
            }

            terminalRegistration(updatedPayload).then((res) => {
                if (res?.status === 201 && res?.data?.message === 'Success') {
                    const isKiosk = (res?.data?.accountType || "").toLowerCase() !== "mytime";
                    const { uuid, terminalId, companyCode } = payload || {};
                    const terminalData = res?.data?.data?.[0] || {};

                    const fallbackSuffix = isKiosk ? 'TERMINAL' : myTime;
                    const templateName = !CommonUtil.isEmptyString(terminalData?.deviceSn)
                        ? terminalData?.deviceSn
                        : `${companyCode}${fallbackSuffix}`;

                    localStorage.setItem("uuid", isKiosk ? uuid : '');
                    localStorage.setItem("terminal", isKiosk ? terminalId : companyCode + myTime)
                    localStorage.setItem("companyCode", updatedPayload?.companyCode);
                    localStorage.setItem('virtualDeviceId', templateName)
                    localStorage.setItem('deviceName', isKiosk ? terminalData.deviceName?.toUpperCase() : 'ZKTKDevice - MyTime'?.toUpperCase())
                    localStorage.setItem('location', isKiosk ? terminalData.location?.toUpperCase() : 'ZKTKBharat-MyTime'?.toUpperCase())
                    localStorage.setItem("accountType", res?.data?.accountType);
                    navigate(REACT_EMPLOYEE_LOGIN_SCREEN);
                } else {
                    enqueueSnackbar(res?.data?.message, {
                        variant: 'error',
                    });
                }
            })
        }
    }

    const isValidToSubmit = () => {

        if (payload?.companyCode?.trim().length === 0) {
            setError({
                ...error,
                companyCode: t("terminalRegistration.errors.companyCodeRequired"),
            });
            return false;
        }

        if (!CommonUtil.isValidCompanyCode(payload?.companyCode)) {
            setError({
                ...error,
                companyCode:t("terminalRegistration.errors.companyCodeInvalid"),
            });
            return false;
        }

        if (payload?.companyCode?.length > 20) {
            setError({
                ...error,
                companyCode:t("terminalRegistration.errors.companyCodeMaxLength"),
            });
            return false;
        }

        return true;
    };

    return (
        <OnboardLayout>
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                sx={{
                    marginTop: { xs: '10px', sm: "15px", md: '10px', lg: '15px', xl: '20px' }
                }}
            >
                <Typography sx={{
                    marginBottom: { xs: '15px', sm: "15px", md: '5px', lg: '15px', xl: '20px' }
                }}
                    variant="resetPasswordTittle"
                >
                {t("terminalRegistration.title")}
                </Typography>
                <CustomInput
                    label= {t("terminalRegistration.labels.companyCode")}
                    required
                    size="small"
                    name="companyCode"
                    placeholder={t("terminalRegistration.placeholders.companyCode")}
                    value={payload.companyCode}
                    handleChange={handleChange}
                    validation={'alpha-numeric-underscore'}
                    error={error.companyCode}
                    helperText={error.companyCode}
                    autoComplete="off"
                    autoFocus
                    sx={{
                        marginBottom: "10px"
                    }}
                />
                <CustomInput
                    label={t("terminalRegistration.placeholders.terminalId")}
                    info={t("terminalRegistration.messages.terminalInfo")}
                    size="small"
                    name="terminalId"
                    placeholder={t("terminalRegistration.placeholders.terminalId")}
                    value={payload.terminalId}
                    handleChange={handleChange}
                    validation={'alpha-numeric'}
                    error={error.terminalId}
                    helperText={error.terminalId}
                    autoComplete="off"
                    autoFocus
                />
                <Button
                    fullWidth
                    variant="contained"
                    sx={{
                        marginTop: { xs: '20px', sm: "20px", md: '20px', lg: '30px', xl: '40px' },
                        mb: 2, backgroundColor: 'rgba(0, 164, 255, 1)', fontFamily: 'inter',
                    }}
                    onClick={handleSubmit}
                >
                    {t("terminalRegistration.buttons.enter")}
                </Button>
            </Box>
        </OnboardLayout>
    )
}
export default TerminalRegistration;